import { useContext, useMemo } from "react";
import brandEventPropertyMapper from "../utils/brandEventPropertyMapper";
import { SNOWPLOW_SCHEMA_DATA_KEY } from "../utils/snowplowEventMigrator";
import brandOfferEntityMapper from "../utils/brandOfferEntityMapper";
import { EssentialWidgetOfferContext } from "../components/EssentialWidget";

const useEssentialWidgetOffer = () => {
	const data = useContext(EssentialWidgetOfferContext);

	// Explicit extraction for ease of intellisense when consuming hook
	const {
		NUM_OFFERS_IDX,
		TOTAL_OFFERS,

		activeOffer,
		activeOfferIdx,
		claimOffer,
		claimedOffers,
		isOfferClaimed,
		isFirstOffer,
		showNextOffer,
		showPrevOffer,
		isLastOffer,

		handleWidgetCardClose,
	} = data;

	const defaultOfferEventProps = useMemo(() => {
		if (!activeOffer) return {};
		return {
			...brandEventPropertyMapper({
				brand: activeOffer,
				idx: activeOfferIdx,
				feedHasUpsell: false,
			}),
			[SNOWPLOW_SCHEMA_DATA_KEY]: {
				...brandOfferEntityMapper({
					brand: activeOffer,
				}),
				horizontalPosition: activeOfferIdx,
			},
		};
	}, [activeOffer, activeOfferIdx]);

	return {
		NUM_OFFERS_IDX,
		TOTAL_OFFERS,

		activeOffer,
		activeOfferIdx,

		claimOffer,
		claimedOffers,
		isOfferClaimed,

		isFirstOffer,
		showNextOffer,
		showPrevOffer,
		isLastOffer,

		handleWidgetCardClose,
		defaultOfferEventProps,
	};
};
export default useEssentialWidgetOffer;
